'use client';
import { useRef, useState, useCallback } from 'react';

const useHover = (options)=>{
    const { timeout } = options || {};
    const timerRef = useRef(0);
    const [hovered, setHovered] = useState(false);
    const onMouseEnter = useCallback(()=>{
        if (timeout) {
            window.clearTimeout(timerRef.current);
        }
        setHovered(true);
    }, []);
    const onMouseLeave = useCallback(()=>{
        if (timeout) {
            timerRef.current = window.setTimeout(()=>setHovered(false), timeout);
        } else {
            setHovered(false);
        }
    }, []);
    return [
        hovered,
        {
            onMouseEnter,
            onMouseLeave
        }
    ];
};

export { useHover };
//# sourceMappingURL=useHover.js.map
